// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"68693753","460":"4f666a0d"}[chunkId] + ".chunk.js";
};